/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-cp': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.82 8.3L9.9.38a1.3 1.3 0 00-1.81 0l-8 8A.38.38 0 00.37 9H1.5v8.62a.38.38 0 00.37.38h4.5a.37.37 0 00.37-.38v-6.38h4.5v6.37a.38.38 0 00.38.38h4.49a.38.38 0 00.38-.38V9h1.13a.37.37 0 00.38-.38.36.36 0 00-.18-.32z"/>'
  }
})
